// extracted by mini-css-extract-plugin
export var cmtCardMedia = "styles-module--cmt-card-media--39a27";
export var cmtCardMediaLayoutLandscape = "styles-module--cmt-card-media--layout-landscape--eb191";
export var cmtCardMediaPositionRight = "styles-module--cmt-card-media--position-right--cff4a";
export var cmtCardMedia__image = "styles-module--cmt-card-media__image--ff28d";
export var cmtCardMedia__pill = "styles-module--cmt-card-media__pill--111cd";